// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-group[data-v-95bf2d3a] {\n  width: 100%;\n}\n.invalidField[data-v-95bf2d3a] {\n  border-color: red;\n}\n", ""]);
// Exports
module.exports = exports;
